module.exports = __webpack_public_path__ + "static/media/relative.91c1e1b8.svg";